<h2 mat-dialog-title>{{ data.label }}</h2>

<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ data.label }}</mat-label>

      @if (data.prefix) {
        <span matTextPrefix>{{ data.prefix }}</span>
      }

      <input
        matInput
        type="number"
        formControlName="value"
        [step]="data.step"
      />

      @if (data.suffix) {
        <span matTextSuffix class="suffix">
            {{ data.suffix }}
        </span>
      }

      @if (form.get('value')?.hasError('max')) {
        <mat-error>
          Maximum value is {{ data.max_value }}
        </mat-error>
      }

      @if (form.get('value')?.hasError('min')) {
        <mat-error>
          Minimum value is {{ data.min_value }}
        </mat-error>
      }
    </mat-form-field>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="clear()">
      Clear
    </button>

    <button mat-button type="button" (click)="cancel()">
      Cancel
    </button>

    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="form.invalid"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>